import { Alert, Flex, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import { MFA_USER_FACING_DEADLINE } from '@/constants/mfa';
import { SPACE_SM } from '@/theme/buildAntdTheme';

const HELPDESK_ARTICLE_URL =
  'https://help.hireport.io/articles/2180368934-moving-from-shared-agency-logins-to-individual-users-2fa-rollout?lang=en';

/**
 * Explains that shared agency logins must be replaced with individual users
 * because of 2FA. Shown on MFA method selection and when disabling 2FA.
 */
const SharedLoginSunsetNotice = () => {
  const [t] = useTranslation();

  return (
    <Alert
      type="info"
      showIcon={false}
      data-testid="mfa-shared-login-notice"
      title={t('MFA_SHARED_LOGIN_TITLE')}
      description={
        <Flex vertical gap={SPACE_SM}>
          <Typography.Text type="secondary" italic>
            {t('MFA_SHARED_LOGIN_IGNORE')}
          </Typography.Text>
          <Typography.Paragraph style={{ marginBottom: 0 }}>
            <Trans
              i18nKey="MFA_SHARED_LOGIN_INTRO"
              components={{ bold: <Typography.Text strong /> }}
            />
          </Typography.Paragraph>
          <Flex vertical gap={4}>
            <Typography.Text>
              <Trans
                i18nKey="MFA_SHARED_LOGIN_STEP_1"
                components={{ bold: <Typography.Text strong /> }}
              />
            </Typography.Text>
            <Typography.Text>{t('MFA_SHARED_LOGIN_STEP_2')}</Typography.Text>
            <Typography.Text>
              <Trans
                i18nKey="MFA_SHARED_LOGIN_STEP_3"
                components={{ bold: <Typography.Text strong /> }}
              />
            </Typography.Text>
            <Typography.Text>{t('MFA_SHARED_LOGIN_STEP_4')}</Typography.Text>
            <Typography.Text>{t('MFA_SHARED_LOGIN_STEP_5')}</Typography.Text>
            <Typography.Text>{t('MFA_SHARED_LOGIN_STEP_6')}</Typography.Text>
          </Flex>
          <Typography.Text strong>
            {t('MFA_SHARED_LOGIN_DEADLINE', {
              date: MFA_USER_FACING_DEADLINE,
            })}
          </Typography.Text>
          <Typography.Text type="secondary">
            {t('MFA_SHARED_LOGIN_AFTERMATH')}
          </Typography.Text>
          <Typography.Link
            href={HELPDESK_ARTICLE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('MFA_SHARED_LOGIN_HELPDESK')}
          </Typography.Link>
        </Flex>
      }
    />
  );
};

export default SharedLoginSunsetNotice;
